import type { ReactNode } from 'react';

interface FieldProps {
  label: string;
  children: ReactNode;
}

export function Field({ label, children }: FieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-primary/60 uppercase tracking-wide">{label}</span>
      <div className="text-primary text-sm">{children}</div>
    </div>
  );
}
